import { useEffect, useState } from "react";
import axios from "axios";
import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Skeleton } from "@/components/ui/skeleton";
import { MarketCard } from "./MarketCard";
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const CHIPS = ["Bitcoin", "BTC", "Crypto", "Fed", "Trump", "Election"];

export const MarketsSection = ({ tick }) => {
  const [q, setQ] = useState("");
  const [query, setQuery] = useState("");
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    const id = setTimeout(() => setQuery(q), 350);
    return () => clearTimeout(id);
  }, [q]);

  useEffect(() => {
    axios.get(`${API}/markets`, { params: { q: query } })
      .then((r) => { setData(r.data); setError(false); })
      .catch(() => setError(true));
  }, [query, tick]);

  return (
    <section className="card p-5 sm:p-6 fade-up" data-testid="markets-section">
      <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-2">
        <div>
          <h2 className="font-head font-bold text-lg">Polymarket US markets</h2>
          <p className="text-xs text-slate-400 mt-1">Active markets, most traded first. Price ≈ the crowd's % chance it happens.</p>
        </div>
        {data && <span className="text-xs font-num text-slate-500" data-testid="markets-count">{data.count} matches</span>}
      </div>
      <div className="relative mt-4">
        <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-slate-500" />
        <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search markets, e.g. bitcoin"
          className="pl-9 bg-[#05070D] border-[#1A2338] h-11" data-testid="market-search-input" />
      </div>
      <div className="flex gap-2 mt-3 overflow-x-auto pb-1">
        {CHIPS.map((c) => (
          <button key={c} onClick={() => setQ(c)} data-testid={`chip-${c.toLowerCase()}`}
            className={`text-xs px-3 py-1.5 rounded-full border whitespace-nowrap transition-colors ${q === c ? "border-[#22D3EE] text-[#22D3EE]" : "border-[#1A2338] text-slate-400 hover:text-slate-200"}`}>
            {c}
          </button>
        ))}
        {q && <button onClick={() => setQ("")} className="text-xs px-3 py-1.5 text-slate-500 hover:text-slate-300" data-testid="chip-clear">Clear</button>}
      </div>
      {error && <p className="text-sm text-red-400 mt-4" data-testid="markets-error">Couldn't load Polymarket US right now.</p>}
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3 mt-4" data-testid="markets-grid">
        {!data && !error && [...Array(6)].map((_, i) => <Skeleton key={i} className="h-44 bg-[#111A2C]" />)}
        {data?.markets.map((m) => <MarketCard key={m.id} m={m} />)}
      </div>
      {data && data.count === 0 && <p className="text-sm text-slate-400 mt-4" data-testid="markets-empty">No active markets match "{query}". Try a simpler word.</p>}
    </section>
  );
};
